export default __webpack_public_path__ + "static/media/car_type_grey.db764ee7.svg";